{
  "$id": "wealthlane://forms/option-award/rules",
  "effects": [
    {
      "id": "participantNameCascade",
      "watch": "#/properties/participantId",
      "set": {
        "#/properties/firstName": {
          "operator": "optionProp",
          "field": "#/properties/participantId",
          "prop": "firstName"
        },
        "#/properties/middleName": {
          "operator": "optionProp",
          "field": "#/properties/participantId",
          "prop": "middleName"
        },
        "#/properties/lastName": {
          "operator": "optionProp",
          "field": "#/properties/participantId",
          "prop": "lastName"
        },
        "#/properties/employeeId": {
          "operator": "optionProp",
          "field": "#/properties/participantId",
          "prop": "employeeId"
        }
      }
    },
    {
      "id": "computeGrantPrice",
      "watch": ["#/properties/issuedUnits", "#/properties/fmvAtGrant"],
      "set": {
        "#/properties/grantPrice": {
          "operator": "multiply",
          "operands": ["#/properties/issuedUnits", "#/properties/fmvAtGrant"]
        }
      }
    },
    {
      "id": "computeGrantValueCreate",
      "watch": ["#/properties/issuedUnits", "#/properties/fmvAtGrant"],
      "mode": "create",
      "set": {
        "#/properties/grantValue": {
          "operator": "multiply",
          "operands": ["#/properties/issuedUnits", "#/properties/fmvAtGrant"]
        }
      }
    },
    {
      "id": "clearAcceptanceOnReject",
      "watch": "#/properties/isAccepted",
      "condition": {
        "field": "#/properties/isAccepted",
        "notEquals": true
      },
      "clear": ["#/properties/acceptanceDate", "#/properties/awardAcceptanceDocumentInput"]
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/clearAdjustmentFields",
      "id": "clearAdjustmentFields",
      "bind": { "prefix": "#" }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/clearCancelShareTypeOnManualTargetCancelled",
      "id": "clearCancelShareTypeOnManualTargetCancelled",
      "bind": { "prefix": "#" }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/copyAsOfToResidual",
      "id": "copyAsOfToResidual",
      "bind": { "prefix": "#" }
    },
    {
      "id": "clearOffsetsOnManualExpirationDate",
      "watch": "#/properties/expirationDate",
      "clear": [
        "#/properties/optionExpirationInMonth",
        "#/properties/optionExpirationInDay"
      ]
    },
    {
      "id": "recomputeExpirationFromOffsets",
      "watch": ["#/properties/optionExpirationInMonth", "#/properties/optionExpirationInDay"],
      "condition": {
        "anyOf": [
          { "field": "#/properties/optionExpirationInMonth", "notEmpty": true },
          { "field": "#/properties/optionExpirationInDay", "notEmpty": true }
        ]
      },
      "set": {
        "#/properties/expirationDate": {
          "operator": "dateOffset",
          "source": {
            "operator": "coalesce",
            "fields": ["#/properties/asOfDate", "#/properties/grantIssueDate"]
          },
          "months": "#/properties/optionExpirationInMonth",
          "days": "#/properties/optionExpirationInDay"
        }
      }
    },
    {
      "id": "resetExpirationOnOffsetsCleared",
      "watch": ["#/properties/optionExpirationInMonth", "#/properties/optionExpirationInDay"],
      "condition": {
        "allOf": [
          { "field": "#/properties/optionExpirationInMonth", "isEmpty": true },
          { "field": "#/properties/optionExpirationInDay", "isEmpty": true },
          { "field": "#/properties/grantIssueDate", "notEmpty": true }
        ]
      },
      "set": {
        "#/properties/expirationDate": {
          "operator": "dateOffset",
          "source": "#/properties/grantIssueDate",
          "years": "#/properties/_optionExpirationInYears"
        }
      }
    },
    {
      "id": "defaultExpirationFromGrant",
      "watch": ["#/properties/grantIssueDate", "#/properties/_optionExpirationInYears"],
      "condition": {
        "allOf": [
          { "field": "#/properties/grantIssueDate", "notEmpty": true },
          { "field": "#/properties/_optionExpirationInYears", "notEmpty": true },
          { "field": "#/properties/optionExpirationInMonth", "isEmpty": true },
          { "field": "#/properties/optionExpirationInDay", "isEmpty": true }
        ]
      },
      "set": {
        "#/properties/expirationDate": {
          "operator": "dateOffset",
          "source": "#/properties/grantIssueDate",
          "years": "#/properties/_optionExpirationInYears"
        }
      }
    },
    {
      "id": "recomputeExpirationOnAsOfDateChange",
      "watch": "#/properties/asOfDate",
      "condition": {
        "anyOf": [
          { "field": "#/properties/optionExpirationInMonth", "notEmpty": true },
          { "field": "#/properties/optionExpirationInDay", "notEmpty": true }
        ]
      },
      "set": {
        "#/properties/expirationDate": {
          "operator": "dateOffset",
          "source": {
            "operator": "coalesce",
            "fields": ["#/properties/asOfDate", "#/properties/grantIssueDate"]
          },
          "months": "#/properties/optionExpirationInMonth",
          "days": "#/properties/optionExpirationInDay"
        }
      }
    },
    {
      "id": "recalcExpirationOnAccelerationCleared",
      "watch": "#/properties/methodType",
      "condition": {
        "allOf": [
          { "field": "#/properties/methodType", "isEmpty": true },
          { "field": "#/properties/grantIssueDate", "notEmpty": true }
        ]
      },
      "set": {
        "#/properties/expirationDate": {
          "operator": "dateOffset",
          "source": "#/properties/grantIssueDate",
          "months": "#/properties/optionExpirationInMonth",
          "days": "#/properties/optionExpirationInDay"
        }
      }
    }
  ],
  "observers": [
    {
      "$ref": "shared://rules/award-adjustment#templates/resolveAdjustmentMethodOnMethodType",
      "id": "resolveAdjustmentMethodOnMethodType",
      "bind": { "prefix": "#" }
    },
    {
      "id": "grantCascade",
      "watch": "#/properties/grantId",
      "lookup": {
        "actionId": "FETCH_OPTION_AWARD_GRANT_DETAIL",
        "paramField": "grantId"
      },
      "mapTo": {
        "planName": "#/properties/planName",
        "planId": "#/properties/planId",
        "planTypeId": "#/properties/planTypeId",
        "planType": "#/properties/planType",
        "grantName": "#/properties/grantName",
        "grantIssueDate": "#/properties/grantIssueDate",
        "isOffline": "#/properties/isOffline",
        "poolId": "#/properties/poolId",
        "vestingTemplateId": "#/properties/vestingTemplateId",
        "vestingTemplateName": "#/properties/vestingTemplateName",
        "optionExpirationInYears": "#/properties/_optionExpirationInYears"
      },
      "debounceMs": 300
    },
    {
      "id": "fmvLookup",
      "watch": "#/properties/grantIssueDate",
      "condition": {
        "field": "#/properties/grantIssueDate",
        "notEmpty": true
      },
      "lookup": {
        "actionId": "FETCH_FMV_MARKET_PRICE_OPTION",
        "params": {
          "awardType": "Options",
          "date": "#/properties/grantIssueDate",
          "issuedUnits": "#/properties/issuedUnits"
        },
        "skipNull": true
      },
      "mapTo": {
        "fmv": "#/properties/fmvAtGrant",
        "grantPrice": "#/properties/grantPrice"
      },
      "debounceMs": 300
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/adjustAwardOnCancelShareType",
      "id": "adjustAwardOnCancelShareType",
      "bind": { "prefix": "#", "adjustmentActionId": "FETCH_OPTION_AWARD_ADJUSTMENT" },
      "mapTo": {
        "targetCancelled": "targetCancelled",
        "optionExpirationInMonths": "#/properties/optionExpirationInMonth",
        "optionExpirationInDays": "#/properties/optionExpirationInDay"
      }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/adjustAwardOnMethodType",
      "id": "adjustAwardOnMethodType",
      "bind": { "prefix": "#", "adjustmentActionId": "FETCH_OPTION_AWARD_ADJUSTMENT" },
      "mapTo": {
        "targetCancelled": "targetCancelled",
        "optionExpirationInMonths": "#/properties/optionExpirationInMonth",
        "optionExpirationInDays": "#/properties/optionExpirationInDay"
      }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/adjustAwardOnAsOfDate",
      "id": "adjustAwardOnAsOfDate",
      "bind": { "prefix": "#", "adjustmentActionId": "FETCH_OPTION_AWARD_ADJUSTMENT" },
      "mapTo": {
        "targetCancelled": "targetCancelled",
        "optionExpirationInMonths": "#/properties/optionExpirationInMonth",
        "optionExpirationInDays": "#/properties/optionExpirationInDay"
      }
    }
  ],
  "rules": [
    {
      "id": "rule_grantReason_noBlank",
      "target": "#/properties/grantReason",
      "rule": "noBlank",
      "message": "No blank spaces"
    },
    {
      "id": "rule_grantReason_noDoubleSpace",
      "target": "#/properties/grantReason",
      "rule": "noDoubleSpace",
      "message": "No consecutive spaces"
    },
    {
      "id": "rule_notes_noBlank",
      "target": "#/properties/notes",
      "rule": "noBlank",
      "message": "No blank spaces"
    },
    {
      "id": "rule_notes_noDoubleSpace",
      "target": "#/properties/notes",
      "rule": "noDoubleSpace",
      "message": "No consecutive spaces"
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/rule_asOfDate_required",
      "id": "rule_asOfDate_required",
      "bind": { "prefix": "#" }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/rule_targetCancelled_required",
      "id": "rule_targetCancelled_required",
      "bind": { "prefix": "#" }
    }
  ]
}
